import { FC, Fragment, ReactNode } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { match } from 'ts-pattern';
import { BreadItem, Container } from './BreadCrumbComponent.style';
interface Props {
  mainSlugColor?: string;
  subSlugColor?: string;
  arrowColor?: string;
  pageName?: string;
}
const BreadCrumbComponent: FC<Props> = ({
  mainSlugColor,
  subSlugColor,
  arrowColor,
  pageName
}: Props) => {
  const renderArrow = (color: string): ReactNode => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g>
                    <path d="M5.93994 13.2802L10.2866 8.93355C10.7999 8.42021 10.7999 7.58021 10.2866 7.06688L5.93994 2.72021" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </svg>;
  };
  const route = useRouter();
  const decodePathName = decodeURI(route.asPath).split('/');
  const pathNameEn = decodePathName.slice(1, 2).toString();
  const slugName = decodePathName.slice(2);
  const mapBreadCrumbPathname = (val: string): string => {
    return match(val).with('product', () => 'ผลิตภัณท์ซีพี').with('collection', () => 'คอลเลกชัน').with('recipe', () => 'เมนูอาหาร').otherwise(() => val);
  };
  const generateSubBreadCrumb = (path: string): ReactNode => {
    return <BreadItem $Color={subSlugColor ?? '#ffffff'}>
                <Link href={`/${path}`}>{mapBreadCrumbPathname(path)}</Link>
                {renderArrow(arrowColor ?? '#ffffff')}
            </BreadItem>;
  };
  return <Container>
            <BreadItem $Color={subSlugColor ?? '#ffffff'}>
                <Link href="/">หน้าหลัก</Link>
                {renderArrow(arrowColor ?? '#ffffff')}
            </BreadItem>

            {generateSubBreadCrumb(pathNameEn)}

            {slugName.map((slug, index) => <Fragment key={index}>
                    {index + 1 === slugName.length ? <BreadItem $Color={mainSlugColor ?? '#ffffff'}>
                            <b>{pageName.toString()}</b>
                        </BreadItem> : generateSubBreadCrumb(slug)}
                </Fragment>)}
        </Container>;
};
export default BreadCrumbComponent;